import React, { useState } from "react";
import { Col, Modal, ModalHeader, ModalBody, Row, Table } from "reactstrap";

interface TransactionProps {
  index: number;
}

const filteredUsers = [
  {
    transactionId: "TXN123456789",
    transactionMethod: "Credit Card",
    date: "12/02/2025",
    time: "07:30 PM",
    amount: "$100.00",
  },
  {
    transactionId: "TXN987654321",
    transactionMethod: "PayPal",
    date: "14/02/2025",
    time: "08:00 PM",
    amount: "$250.50",
  },
  {
    transactionId: "TXN567890123",
    transactionMethod: "UPI",
    date: "10/02/2025",
    time: "09:00 AM",
    amount: "$75.99",
  },
  {
    transactionId: "TXN234567890",
    transactionMethod: "Debit Card",
    date: "15/02/2025",
    time: "11:30 AM",
    amount: "$300.00",
  },
  {
    transactionId: "TXN876543210",
    transactionMethod: "Net Banking",
    date: "16/02/2025",
    time: "07:00 PM",
    amount: "$120.75",
  },
  {
    transactionId: "TXN876543210",
    transactionMethod: "Net Banking",
    date: "16/02/2025",
    time: "07:00 PM",
    amount: "$120.75",
  },
  {
    transactionId: "TXN876543210",
    transactionMethod: "Net Banking",
    date: "16/02/2025",
    time: "07:00 PM",
    amount: "$120.75",
  },
  {
    transactionId: "TXN876543210",
    transactionMethod: "Net Banking",
    date: "16/02/2025",
    time: "07:00 PM",
    amount: "$120.75",
  },
  {
    transactionId: "TXN876543210",
    transactionMethod: "Net Banking",
    date: "16/02/2025",
    time: "07:00 PM",
    amount: "$120.75",
  },
  {
    transactionId: "TXN876543210",
    transactionMethod: "Net Banking",
    date: "16/02/2025",
    time: "07:00 PM",
    amount: "$120.75",
  },
];

const 
 Transaction: React.FC<TransactionProps> = ({ index }) => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <Row>
      <Col>
        <i
          className="bi bi-eye"
          id={`popover-${index}`}
          onClick={toggle}
          style={{ cursor: "pointer" }}
        ></i>
      </Col>
      <Col>
        <Modal isOpen={modal} toggle={toggle} centered size="lg" fade={false}>
          <ModalHeader toggle={toggle}>Payment Transaction Table</ModalHeader>
          <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table responsive size="sm" striped className="dataTable">
              <thead>
                <tr>
                  <th>Transaction Id</th>
                  <th>Transaction Method</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user: any, index: any) => (
                  <tr key={index}>
                    <td>{user.transactionId}</td>
                    <td>{user.transactionMethod}</td>
                    <td>{user.date}</td>
                    <td>{user.time}</td>
                    <td>{user.amount}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>
      </Col>
    </Row>
  );
};

export default Transaction;
